<div class="eforall-common-field form-floating">

	@let currentField = field();
	@let state = currentField.formField();
	@let validations = currentField.validations;

	@if(currentField.isMultiLine){
	<!-- using value bcoz textArea doesn't support null value, so we need to set it to empty string if null -->
	<textarea class="form-control"
		[id]="randomId"
		[placeholder]="displayLabel()"
		[disabled]="state.disabled()"
		[value]="state.value() ?? ''"
		(input)="onInput($event)"
		(blur)="state.markAsTouched()"
		style="resize: none;"
		[style.min-height.em]="currentField.minHeight ?? 8"></textarea>

	} @else {
	<input class="form-control"
		[id]="randomId"
		[type]="inputType()"
		[placeholder]="displayLabel()"
		[disabled]="state.disabled()"
		[value]="state.value() ?? ''"
		(input)="onInput($event)"
		(blur)="state.markAsTouched()" />
	}

	<label [for]="randomId" class="color-gray d-flex w-100">
		{{ displayLabel() }}
		@if (!validations || !validations.isRequired?.()) {
		<span class="ps-1">(optional)</span>
		}

		@if(currentField.isMultiLine && validations?.maxLength){
		<div class="ms-auto text-end">{{state.value()?.length ?? 0}} / {{validations.maxLength}}</div>
		}
	</label>

	@if (state.touched() && state.invalid()) {
	<div class="error-message" role="alert">
		@for (error of state.errors(); track error) {
		<div class="color-darkred text-end" style="font-size: 14px">{{ error.message }}</div>
		}
	</div>
	}
</div>